<template>
  <div class="menu-translation-tooltip-row" :class="{
      selected: isSelected
  }">
      <img :src="`/flags/${locale}.png`" @click="emitValue"/>
      <div class="w-100 gap-row-zero" @click="emitValue">
          <div class="qrw-label-lg bold w-100" :class="{
              'v1-grey-10-color': !isSelected,
              'white-color': isSelected
          }">
              {{ localeName }}
          </div>
          <div class="qrw-label-xs w-100" :class="{
              'v1-grey-7-color': !isSelected,
              'green-1-color': isSelected
          }">
              {{ isOriginal ? $t('menu_languages.main_language') : $t('menu_languages.alt_language') }}
          </div>
      </div>
      <BaseButton variant="tertiary" size="md" :color="isSelected ? 'v1-grey-1' : 'v1-grey-10'" icon="pencil" @click="$emit('edit')" v-if="isOriginal"/>
      <BaseButton variant="tertiary" size="md" :color="isSelected ? 'v1-grey-1' : 'red-4'" icon="trash" @click="$emit('delete')" v-else/>
  </div>
</template>

<script>
import LanguageNames from "@/i18n/language_names.js"

export default {
    props: {
        locale: String,
        isOriginal: Boolean,
        value: String
    },
    methods: {
        emitValue() {
            this.$emit('input', this.isOriginal ? null : this.locale);
        }
    },
    computed: {
        localeName() {
            return LanguageNames[this.locale];
        },
        isSelected() {
            return this.isOriginal ? this.value === null : this.value == this.locale;
        }
    }
}
</script>

<style scoped>
.menu-translation-tooltip-row {
    display: flex;
    background: var(--v1-grey-1-color);

    padding: 12px 8px 12px 16px;

    flex-direction: row;
    column-gap: 8px;

    align-items: center;
    align-content: center;

    cursor: pointer;
}

.menu-translation-tooltip-row:hover {
    background: var(--v1-grey-2-color);
}

.menu-translation-tooltip-row.selected {
    background: var(--green-5-color);
}

.menu-translation-tooltip-row img {
    width: 22px;
    height: 22px;
    max-width: 22px;
}
</style>